<template>
  <div id="buyCrypto">
    <!-- 卖币功能模块 -->
    <div class="buyCrypto_content">
      <div class="methods_select cursor">
        <div class="form_title pay_title">{{ $t('homePage.youSell') }}</div>

        <template v-if="currencyData.name">
          <div class="flex" :class="{ inputFocus: inputFocus }">
            <div class="methods_select-left">
              <van-field class="pay_input" type="number" v-model.number="payAmount" @focus="inputFocus = true" @blur="inputFocus = false" @input="inputChange" :disabled="payAmountState" inputmode="decimal" placeholder="0.00" :formatter="payAmountFormatter" />
            </div>
            <div class="get_company" @click="openSearch('currency-sell')">
              <div class="getImg">
                <img class="coinImg" :src="currencyData.icon" />
                <img v-if="currencyData.sellNetwork && currencyData.sellNetwork.logo" class="networkImg" :src="currencyData.sellNetwork.logo" />
              </div>
              <div class="getText">{{ currencyData.name }}</div>
              <div class="rightIcon"><img src="@/assets/images/homeRight-icon2.svg" /></div>
            </div>
          </div>
        </template>
        <content-loader primaryColor="#f5f5f5" secondaryColor="#ffffff" :secondaryOpacity="0.5" v-else :width="343" :height="48">
          <rect x="0" y="0" width="100%" height="100%" rx="6" ry="6" />
        </content-loader>
      </div>
      <div class="methods_select cursor get_methods_select">
        <div class="form_title">{{ $t('homePage.buyFee_title1') }}</div>
        <template v-if="payCommission.code">
          <div class="flex" :class="{ warningTextState: warningTextState }">
            <div class="methods_select-left">
              <div class="get_input">
                <span v-if="getAmount !== ''">{{ getAmount }}</span>
                <span class="no_getAmount" v-else>0.00</span>
              </div>
            </div>
            <div class="get_company" @click="openSearch('payCurrency-sell')">
              <div class="get_company_flex">
                <div class="getImg"><img :src="positionData.positionImg" /></div>
                <div class="getText">{{ payCommission.code }}</div>
                <img class="rightIcon" src="@/assets/images/homeRight-icon2.svg" />
              </div>
            </div>
          </div>
        </template>
        <content-loader primaryColor="#f5f5f5" secondaryColor="#ffffff" :secondaryOpacity="0.5" v-else :width="343" :height="48">
          <rect x="0" y="0" width="100%" height="100%" rx="6" ry="6" />
        </content-loader>
        <div class="warning_text" :class="{ show_warning_text: warningTextState }">
          <span v-if="warningTextState" v-html="payAmount_tips"></span>
        </div>
      </div>
      <!-- 费用模块 -->
      <div class="calculationProcess" v-if="detailedInfo_state">
        <IncludedDetailsSell v-show="payAmount_tips === ''" ref="includedDetails_ref" :isHome="true" />
      </div>
      <content-loader primaryColor="#f5f5f5" secondaryColor="#ffffff" :secondaryOpacity="0.5" v-else-if="!detailedInfo_state && !warningTextState" :width="343" :height="43">
        <rect x="243" y="0" width="100" height="14" rx="6" ry="6" />
        <rect x="0" y="21" width="100" height="22" rx="6" ry="6" />
        <rect x="143" y="21" width="200" height="22" rx="6" ry="6" />
      </content-loader>

      <button class="continue" @click="nextStep" :disabled="!continueState" :class="{ continue_true: continueState }">
        {{ $t('homePage.bottomTips1') }} {{ currencyData.name }}
        <img v-if="lodingStatus" class="rightIcon" src="@/assets/images/button-right-icon.svg" alt="" />
        <button-loading v-else class="rightIcon" />
      </button>
    </div>

    <div class="footer">
      <powered-by :show-pay-way="true" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { hashQuery } from '@/utils/publicRequest';
import common from '../../../utils/common';
import { digitalInputFormatter } from '@/utils';

import IncludedDetailsSell from '../../../components/IncludedDetails/IncludedDetails-sell';

export default {
  name: 'sellCrypto',
  components: { IncludedDetailsSell },
  props: ['allBasicData'],
  data() {
    return {
      //All data
      basicData: {},

      //Location data
      positionData: {
        positionValue: '',
        positionImg: '',
        alpha2: '',
        code: ''
      },

      payAmount: '',
      getAmount: '',

      //Expense information
      feeInfo: {},
      detailedInfo_state: false,

      //you get Currency information
      currencyData: {
        icon: '',
        name: '',
        maxSell: '',
        minSell: '',
        cryptoCurrencyNetworkId: '',
        symbol: ''
      },

      //Payment method information
      payCommission: {},
      allPayCommission: [],

      triggerType: 'hover',

      inputFocus: false,
      lodingStatus: true,
      //接收商户数据
      accessMerchantInfo: {},
      //商户携带参数输入框状态
      detailedInfo_cryptoAmount: false,

      //控制加密货币可选择
      cryptoSate: false,
      //控制国家可选择
      fiatSate: false
      //法币兑换美元的金额加按钮禁用
      // exchange:false
    };
  },

  mounted() {
    //配置商户获取携带的加密货币值
    // this.accessMerchantInfo = JSON.parse(sessionStorage.getItem('buyMerchantInfo'))
    // if(this.accessMerchantInfo.cryptoAmount){
    //     this.payAmount = this.accessMerchantInfo.cryptoAmount
    // }
  },
  computed: {
    // 商户信息
    ...mapState('buyCryptoMerchant', {
      merchantInfo: state => state.merchantInfo
    }),

    //you pay Input status - Data can only be entered after loading
    payAmountState() {
      return Boolean(this.detailedInfo_cryptoAmount);
    },
    //确认按钮状态
    continueState() {
      //取消最大最小值
      if (this.positionData.positionValue !== '' && this.payAmount !== '' && this.getAmount !== '' && this.payAmount_tips === '' && Number(this.payAmount) > 0 && this.lodingStatus) {
        //增加loding效果
        return true;
      } else {
        return false;
      }
    },
    warningTextState: {
      get() {
        return !!this.payAmount_tips.trim();
      },
      set() {}
    },
    payAmount_tips() {
      //单个商户配置最大金额
      // const appId = 'mep88Oysd18jMhOr';
      // let UsdMax = JSON.parse(sessionStorage.getItem('buyMerchantInfo'));
      // var minError;
      // let fixedCode = this.feeInfo.rateUsd;
      // //获取60美元换算成法币是多少
      // let minamountUsd = 80 * fixedCode;
      // //单个商户配置最大金额75000美元
      // let maxamountUsd = UsdMax && UsdMax.appId && UsdMax.appId === appId ? 75000 * fixedCode : 10000 * fixedCode;
      // //查看换算的是否有小数点 如果有小数位直接+1否则则下一步
      // var result = minamountUsd.toString().indexOf('.');
      // var result1 = maxamountUsd.toString().indexOf('.');
      // if (result != -1) {
      //   minamountUsd = Number(minamountUsd.toString().substring(0, result)) + 1;
      // }
      // if (result1 != -1) {
      //   maxamountUsd = Number(maxamountUsd.toString().substring(0, result1)) + 1;
      // }

      let minError = '';

      if (Number(this.getAmount) < this.currencyData.minSell) {
        minError = `${this.$t('homePage.sellminAmount')} ${this.currencyData.minSell} ${this.$store.state.sellRouterParams.positionData.code}.`;
      } else if (Number(this.getAmount) > this.currencyData.maxSell) {
        minError = `${this.$t('homePage.sellmaxAmount')} ${this.currencyData.maxSell} ${this.$store.state.sellRouterParams.positionData.code}.`;
      }
      return minError;
    }
  },
  watch: {
    allBasicData: {
      immediate: true,
      deep: true,
      handler() {
        let state = sessionStorage.getItem('merchantType') && sessionStorage.getItem('merchantType') === 'buy' && this.$store.state.tableState === true;
        if (state) {
          return;
        }
        this.allBasicData.worldList !== undefined ? this.currentLocation() : '';
      }
    },
    payAmount: {
      deep: true,
      handler(newVal, oldVal) {
        this.getAmount = '';
        this.amountControl();
      }
    }
  },
  methods: {
    //选择法币或加密货币
    openSearch(view) {
      //存在商户无法切换法币、加密货币
      if (view === 'currency-sell' && this.cryptoSate === false) {
        return;
      }
      if (view === 'payCurrency-sell' && this.fiatSate === false) {
        return;
      }
      this.$parent.openSearch(view);
    },

    payAmountFormatter(str) {
      return digitalInputFormatter(str);
    },

    //限制输入六位小数
    inputChange(val) {
      if (val.indexOf('.') > 0) {
        this.payAmount = val.substr(0, val.indexOf('.') + 7);
      }
    },

    //Process the quantity and display status of received legal currency
    amountControl() {
      //Purchase amount prompt
      if (Number(this.payAmount) !== '' && Number(this.payAmount) > 0) {
        this.$store.state.sellRouterParams.amount = this.payAmount;
        //How many digital currencies can I exchange
        this.payinfo();
      } else {
        this.detailedInfo_state = false;
      }
    },

    //Purchase information details - Scheduled refresh
    payinfo() {
      if (Number(this.payAmount)) {
        this.detailedInfo_state = true;
        setTimeout(() => {
          document.getElementById('buyCrypto').scrollIntoView({ behavior: 'smooth', block: 'end' });
        });
      } else {
        this.detailedInfo_state = false;
      }
    },

    //基本数据处理
    currentLocation() {
      let state = sessionStorage.getItem('buyMerchantInfo') && JSON.parse(sessionStorage.getItem('buyMerchantInfo')).showTable === 'buy';
      if (state) {
        return;
      }
      if (JSON.stringify(this.allBasicData) !== '{}') {
        //提示效果判断
        this.triggerType = common.equipmentEnd === 'pc' ? 'hover' : 'click';
        this.basicData = this.allBasicData;
        //卖币法币国家处理 - 将法币和国家数据合并在一起
        this.basicData.worldList.forEach((item, index) => {
          if (item.sellFiatList) {
            item.sellFiatList.forEach((item2, index2) => {
              this.basicData.fiatCurrencyList.forEach(item3 => {
                if (item3.code === item2) {
                  this.basicData.worldList[index].sellFiatList[index2] = item3;
                }
              });
            });
          }
        });
        if (this.basicData.sellRecentWorldList) {
          this.basicData.sellRecentWorldList.forEach((item, index) => {
            if (item.sellFiatList) {
              item.sellFiatList.forEach((item2, index2) => {
                this.basicData.fiatCurrencyList.forEach(item3 => {
                  if (item3.code === item2) {
                    this.basicData.sellRecentWorldList[index].sellFiatList[index2] = item3;
                  }
                });
              });
            }
          });
        }

        //判断是否需要走卖币商户逻辑 - 不是卖币商户默认数据处理
        let merchantType = sessionStorage.getItem('merchantType');
        if (merchantType !== 'sell') {
          //默认法币、国家、数字货币、网络
          this.basicDataDefault(true, true);
          this.fiatSate = true;
        }
      }
    },

    //加密币、法币、国家默认数据
    /**
     * @param legalCurrencyWorld - 法币国家是否默认
     * @param currencyNetwork - 加密币网络是否默认
     */
    basicDataDefault(legalCurrencyWorld, currencyNetwork) {
      //获取定位的国家信息
      if (legalCurrencyWorld === true) {
        // this.fiatSate = true;
        var worldData = {};
        worldData = this.basicData.worldList.filter(item => {
          if (item.alpha2 === this.basicData.param.areaCode) {
            return item;
          }
        });

        //定位国家法币不可卖，默认第一个可以卖的国家法币
        if (worldData[0].sellEnable === 0) {
          worldData = this.basicData.worldList.filter(item => {
            return item.sellEnable === 1;
          });
        }
        this.handlePayWayList(worldData[0], 1);
      }
      if (currencyNetwork === true) {
        this.cryptoSate = true;
        this.handleDigitalCurrency({}, 1);
      }
    },

    //处理数字货币数据
    handleDigitalCurrency(data, state) {
      // state - 1初始化数据处理 state - 2对选择额数据处理
      if (state === 1) {
        let currencyData_default = [];

        currencyData_default = this.basicData.cryptoCurrencyResponse.cryptoCurrencyList.filter(item => {
          // return item.name === 'BTC';
          return item.name === 'USDT';
        })[0];

        // console.log('currencyData_default45', currencyData_default);
        if (currencyData_default === undefined || currencyData_default.isSell !== 1) {
          currencyData_default = this.basicData.cryptoCurrencyResponse.cryptoCurrencyList.filter(item => {
            return item.isSell === 1;
          })[0];
        }

        if (currencyData_default) {
          let sellNetworkList;
          if (currencyData_default.name === 'USDT') {
            currencyData_default.sellNetworkList.some(item => {
              if (item.network === 'TRX') {
                sellNetworkList = item;
                return true;
              }
            });
          }

          if (!sellNetworkList) {
            sellNetworkList = currencyData_default.sellNetworkList[0];
          }

          this.currencyData = {
            icon: currencyData_default.logoUrl,
            name: currencyData_default.name,
            maxSell: sellNetworkList?.maxSell,
            minSell: sellNetworkList?.minSell,
            cryptoCurrencyNetworkId: currencyData_default.cryptoCurrencyNetworkId,
            sellNetwork: sellNetworkList
          };
          this.$store.state.feeParams.symbol = currencyData_default.symbol; //name -- popularList币种
          this.$store.state.feeParams_order.symbol = currencyData_default.symbol; //name -- popularList币种
          this.$store.state.sellRouterParams.cryptoCurrency = currencyData_default.name;
          this.$store.state.sellRouterParams.currencyData = this.currencyData;

          this.payAmount = 300;
        }
      }
    },

    // 根据国家对应的币种处理数据
    handlePayWayList(data, state) {
      // state - 1初始化数据处理 state - 2对选择额数据处理
      if (state === 1) {
        this.payCommission = data.sellFiatList[0];
        this.positionData.code = data.sellFiatList[0].code;
      } else {
        this.payCommission = {
          code: data.fiat
        };
      }

      //展示所需国家参数
      this.positionData = {
        positionValue: data.enCommonName,
        positionImg: data.flag,
        alpha2: data.alpha2,
        code: this.payCommission.code,
        enCommonName: data.enCommonName
      };
      //费用所需参数
      this.$store.state.sellRouterParams.payCommission = this.payCommission;
      this.$store.state.feeParams.fiatCode = this.payCommission.code;
      this.$store.state.feeParams.alpha2 = data.alpha2;
      this.$store.state.feeParams_order.fiatCode = this.payCommission.code;
      this.$store.state.feeParams_order.alpha2 = data.alpha2;
      this.$store.state.sellRouterParams.positionData = this.positionData;
      this.$store.state.sellRouterParams.formPositionData = this.positionData;
      this.amountControl();
    },

    //卖币接入商户信息接收、验证
    merchantInformationAssignment(res, merchantParams) {
      let state = sessionStorage.getItem('buyMerchantInfo') && JSON.parse(sessionStorage.getItem('buyMerchantInfo')).showTable === 'buy';
      if (state) {
        return;
      }
      //判断是否需要走卖币商户逻辑
      let merchantType = sessionStorage.getItem('merchantType');
      if (merchantType === 'sell') {
        //商户信息接口success创建订单添加merchantParam参数
        if (res && res.returnCode === '0000' && res.data) {
          // this.fiatSate = true;
          // 控制加密货币是否可选
          this.cryptoSate = merchantParams.crypto ? false : true;

          merchantParams.merchantParam = JSON.stringify(hashQuery().query) !== '{}' ? hashQuery().fullPath : JSON.parse(sessionStorage.getItem('buyMerchantInfo')).merchantParam;

          merchantParams.merchantParam_state = true;

          // 商户是否携带商户名称，就使用返回的商户名称
          if (!JSON.parse(sessionStorage.getItem('buyMerchantInfo')).merchantName) {
            merchantParams.merchantName = res.data?.merchantName;
          }

          sessionStorage.setItem('buyMerchantInfo', JSON.stringify(merchantParams));

          let routeInfo = JSON.parse(JSON.stringify(hashQuery()));
          let allMerchantInfo = {
            //商户类型
            merchantType: 'sell', //api、page
            //商户状态
            merchantStatus: true,
            //api商户信息｜page商户信息 | sell商户信息
            merchantQueryInfo: routeInfo.fullPath ? routeInfo.query : this.merchantInfo.merchantQueryInfo,
            //商户地址栏信息
            merchantFullPath: routeInfo.fullPath ? routeInfo.fullPath : this.merchantInfo.merchantFullPath
          };
          this.$store.commit('buyCryptoMerchant/set_merchantInfo', allMerchantInfo);

          //匹配商户携带加密币和网络
          if (merchantParams && merchantParams.crypto) {
            let merchantCurrency = this.basicData.cryptoCurrencyResponse.cryptoCurrencyList.filter(item => {
              return item.name === merchantParams.crypto;
            })[0];

            let merchantNetwork = merchantParams.networkDefault
              ? merchantCurrency.sellNetworkList.filter(item => {
                  return item.network === merchantParams.network;
                })[0]
              : merchantCurrency.sellNetworkList[0];

            this.currencyData = {
              icon: merchantCurrency.logoUrl,
              name: merchantCurrency.name,
              maxSell: merchantCurrency.sellNetworkList[0].maxSell,
              minSell: merchantCurrency.sellNetworkList[0].minSell,
              cryptoCurrencyNetworkId: merchantCurrency.cryptoCurrencyNetworkId,
              sellNetwork: merchantNetwork
            };
            this.$store.state.feeParams.symbol = merchantCurrency.symbol; //name -- popularList币种
            this.$store.state.feeParams_order.symbol = merchantCurrency.symbol; //name -- popularList币种
            this.$store.state.sellRouterParams.cryptoCurrency = merchantCurrency.name;
            this.$store.state.sellRouterParams.currencyData = this.currencyData;
          } else {
            //没有匹配到默认数据
            this.handleDigitalCurrency({}, 1);
          }

          //法币匹配国家 - 则匹配第一个支持法国  如果商户传USD则匹配美国
          if (merchantParams.fiat && !merchantParams.country) {
            let fiat = this.basicData.worldList.filter(item => {
              if (merchantParams.fiat === 'USD') {
                if (item.alpha2 === 'US') {
                  return item.sellFiatList.find(item1 => {
                    return item1.code == merchantParams.fiat;
                  });
                }
                return;
              }
              if (merchantParams.fiat === 'EUR') {
                if (item.alpha2 === 'FR') {
                  return item.sellFiatList.find(item1 => {
                    return item1.code == merchantParams.fiat;
                  });
                }
                return;
              }
              return item.sellFiatList.find(item1 => {
                return item1.code == merchantParams.fiat;
              });
            });
            if (fiat[0]) {
              this.handlePayWayList(fiat[0], 1);
              // this.fiatSate = false;
            }
          } else if (merchantParams && merchantParams.country) {
            //匹配法币国家
            if ((!merchantParams.fiat && merchantParams.country) || (merchantParams.fiat && merchantParams.country)) {
              let country = this.basicData.worldList.filter(item => {
                return item.alpha2 == merchantParams.country && item.sellEnable === 1;
              })[0];
              country.sellFiatList = country.sellFiatList.filter(fiatData => {
                return fiatData.code === merchantParams.fiat;
              });
              this.handlePayWayList(country, 1);
              // this.fiatSate = false;
            }
          } else {
            //默认法币国家
            this.basicDataDefault(true, false);
            this.fiatSate = true;
          }

          //商户接入如果携带值时付给页面并且无法更改
          if (merchantParams && merchantParams.crypto && merchantParams.cryptoAmount) {
            this.payAmount = merchantParams.cryptoAmount;
            this.detailedInfo_cryptoAmount = true;
          }

          this.merchantStatusManagement(res, merchantParams);
        } else {
          // 验签全部失败
          this.merchantStatusManagement(res, merchantParams);
          //默认法币、国家、数字货币、网络
          this.basicDataDefault(true, true);
        }
      }
    },

    // 获取商户logo
    // getMerchantLogo() {
    //   let merchantInfo = '';
    //   if (JSON.stringify(hashQuery().query) !== '{}') {
    //     merchantInfo = hashQuery().fullPath;
    //   } else if (JSON.stringify(hashQuery().query) === '{}' && this.merchantInfo.merchantType !== 'api' && this.merchantInfo.merchantStatus) {
    //     merchantInfo = this.merchantInfo.merchantFullPath;
    //   }
    //   let params = {
    //     appId: this.merchantInfo.merchantStatus ? this.merchantInfo.merchantQueryInfo?.appId : ''
    //   }
    //   this.$axios.post(this.$api.post_buyInfoFee + '?' + merchantInfo, params, '').then(res => {
    //     if (res.data?.merchantConfig?.merchantLogo) {
    //       this.$store.commit('buyCryptoMerchant/set_merchantLogo', res.data.merchantConfig.merchantLogo);
    //     } else {
    //       this.$store.commit('buyCryptoMerchant/set_merchantLogo', '');
    //     }
    //   });
    // },

    //商户状态管理
    /**
     * @param res - 商户校验参数回调
     * @param merchantParams - 需要存储商户信息
     */
    merchantStatusManagement(res, merchantParams) {
      // 商户信息有效获取商户logo
      // if (res && res.returnCode === '0000') {
      //   this.getMerchantLogo()
      // }

      //商户信息有效、network和address参数无效
      if (res && res.returnCode === '0000' && res.success === true && res.data === null) {
        merchantParams.addressDefault = false;
        merchantParams.networkDefault = false;
        sessionStorage.setItem('buyMerchantInfo', JSON.stringify(merchantParams));
        let routeInfo = JSON.parse(JSON.stringify(hashQuery()));
        let allMerchantInfo = {
          //商户类型
          merchantType: 'sell', //api、page
          //商户状态
          merchantStatus: true,
          //api商户信息｜page商户信息 | sell商户信息
          merchantQueryInfo: routeInfo.fullPath ? routeInfo.query : this.merchantInfo.merchantQueryInfo,
          //商户地址栏信息
          merchantFullPath: routeInfo.fullPath ? routeInfo.fullPath : this.merchantInfo.merchantFullPath
        };
        this.$store.commit('buyCryptoMerchant/set_merchantInfo', allMerchantInfo);
        return;
      }

      //商户信息有效、network｜address参数有效
      if (res && res.returnCode === '0000' && res.success === true && res.data !== null) {
        //address: false - Address is not brought out by default
        if (res.data.address === false || res.data.address === undefined) {
          //No parameter defaults
          merchantParams.addressDefault = false;
        } else {
          merchantParams.addressDefault = true;
        }

        //network: false - The network is not brought out by default
        if (res.data.network === false || res.data.network === undefined) {
          //No parameter defaults
          merchantParams.networkDefault = false;
        } else {
          merchantParams.networkDefault = true;
        }

        sessionStorage.setItem('buyMerchantInfo', JSON.stringify(merchantParams));

        let routeInfo = JSON.parse(JSON.stringify(hashQuery()));
        let allMerchantInfo = {
          //商户类型
          merchantType: 'sell', //api、page
          //商户状态
          merchantStatus: true,
          //api商户信息｜page商户信息 | sell商户信息
          merchantQueryInfo: routeInfo.fullPath ? routeInfo.query : this.merchantInfo.merchantQueryInfo,
          //商户地址栏信息
          merchantFullPath: routeInfo.fullPath ? routeInfo.fullPath : this.merchantInfo.merchantFullPath
        };
        this.$store.commit('buyCryptoMerchant/set_merchantInfo', allMerchantInfo);
        return;
      }

      //商户信息无效
      this.fiatSate = true;
      this.cryptoSate = true;
      this.payAmount = '';
      this.detailedInfo_cryptoAmount = false;
      merchantParams.addressDefault = false;
      merchantParams.networkDefault = false;
      merchantParams.merchantParam_state = false;
      sessionStorage.setItem('buyMerchantInfo', JSON.stringify(merchantParams));
      let routeInfo = JSON.parse(JSON.stringify(hashQuery()));
      let allMerchantInfo = {
        //商户类型
        merchantType: 'sell', //api、page
        //商户状态
        merchantStatus: false,
        //api商户信息｜page商户信息 | sell商户信息
        merchantQueryInfo: routeInfo.fullPath ? routeInfo.query : this.merchantInfo.merchantQueryInfo,
        //商户地址栏信息
        merchantFullPath: routeInfo.fullPath ? routeInfo.fullPath : this.merchantInfo.merchantFullPath
      };
      this.$store.commit('buyCryptoMerchant/set_merchantInfo', allMerchantInfo);
      this.$store.commit('buyCryptoMerchant/set_merchantLogo', '');
    },

    nextStep() {
      this.$store.state.historyTab = 'sell';

      //是否是从菜单进入
      this.$store.commit('changeRouterQueryPath', false);
      this.lodingStatus = false;

      //清空邮件单页面跳转状态
      this.$store.state.emailFromPath = '';

      //跳转填写卡信息
      this.$store.state.homeTabstate = 'sellCrypto';
      this.$store.state.cardInfoFromPath = 'configSell';

      delete this.$store.state.sellForm;
      delete this.$store.state.sellRouterParams.cardInfoList;
      //是否为风险
      if (localStorage.getItem('token')) {
        this.$router.push('/sell-formUserInfo');
        setTimeout(() => {
          this.lodingStatus = true;
        }, 1000);
      } else {
        this.$store.state.emailFromPath = 'sellCrypto';
        // 修改地址栏信息(功能: 清除地址栏商户信息)
        if ((sessionStorage.getItem("merchantType") && sessionStorage.getItem("merchantType") === 'buy') || !sessionStorage.getItem("merchantType")) {
          window.history.replaceState(null, null, '/#/emailCode');
        }
        this.$router.push('/emailCode');
        setTimeout(() => {
          this.lodingStatus = true;
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pay_input ::v-deep .van-field__control:disabled {
  color: #0059da !important;
  -webkit-text-fill-color: #0059da !important;
}

// UI-2.0.1
#buyCrypto {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .buyCrypto_content {
    .methods_select {
      position: relative;
      .form_title {
        font-family: 'SF Pro Display';
        font-style: normal;
        font-weight: 500;
        font-size: 0.14rem;
        line-height: 0.18rem;
        color: #252830;
        margin-bottom: 0.06rem;
        // color: red;
      }
      .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 0.48rem;
        background: #ffffff;
        border: 1px solid #e6e8eb;
        border-radius: 0.06rem;
        padding: 0 0.16rem;
        &.inputFocus {
          border-color: #0059da;
        }
        &.warningTextState {
          border-color: #f53f3f;
        }

        .methods_select-left {
          ::v-deep .pay_input {
            width: 100%;
            padding: 0 0.24rem 0 0;
            .van-cell__value {
              .van-field__body {
                .van-field__control {
                  font-family: 'HarmonyOS Sans';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 0.2rem;
                  line-height: 0.28rem;
                  color: #252830;
                  border: none;
                  outline: none;
                  &::placeholder {
                    color: #b7bcc5;
                  }
                }
              }
            }
          }
        }

        .get_company {
          display: flex;
          align-items: center;
          padding-left: 0.16rem;
          position: relative;
          &:before {
            content: '';
            position: absolute;
            width: 0.01rem;
            height: 0.4rem;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background: linear-gradient(180deg, rgba(208, 212, 219, 0) 0%, #e6e8eb 45.31%, rgba(208, 212, 219, 0) 100%);
          }
          .getImg {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 0.24rem;
            height: 0.24rem;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
            .coinImg {
              width: 100%;
              height: auto;
              border-radius: 50%;
            }
            .networkImg {
              position: absolute;
              width: 0.14rem;
              height: auto;
              bottom: -0.04rem;
              right: -0.04rem;
              border: 0.01rem solid #fff;
              border-radius: 50%;
              background: #fff;
            }
          }
          .getText {
            font-family: 'SF Pro Display';
            font-style: normal;
            font-weight: 500;
            font-size: 0.16rem;
            line-height: 0.2rem;
            text-align: center;
            color: #252830;
            margin: 0 0.04rem;
            min-width: 0.42rem;
          }
          .rightIcon {
            width: 0.08rem;
            height: 0.08rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .warning_text {
        // position: absolute;
        // top: 100%;
        // left: 0;
        margin-top: 1px;
        height: 0;
        font-family: 'SF Pro Display';
        font-style: normal;
        font-weight: 400;
        font-size: 0.12rem;
        line-height: 0.18rem;
        color: #f53f3f;
        transition: all 0.3s;
        &.show_warning_text {
          height: 0.18rem;
        }
      }
      & .cursor {
        cursor: auto;
      }
    }
    .get_methods_select {
      margin: 0.2rem 0 0.28rem 0;
      .form_title {
      }
      .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .methods_select-left {
          flex: 1;
          padding-right: 0.24rem;
          overflow: auto;
          .get_input {
            width: auto;
            overflow: auto;
            font-family: 'HarmonyOS Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 0.2rem;
            line-height: 0.28rem;
            span {
              color: #252830;
            }
            .no_getAmount {
              color: #b7bcc5;
            }
          }
        }
        .get_company {
          display: flex;
          flex-direction: column;

          align-items: flex-end;

          .get_company_flex {
            display: flex;
            align-items: center;
            .getImg {
              & > img {
              }
              .networkIcon {
                img {
                }
              }
            }
            .getText {
            }
            .rightIcon {
              img {
              }
            }
          }
          .network-name {
            margin-top: 0.04rem;
            height: 0.14rem;
            background: #b7bcc5;
            border-radius: 0.02rem;
            white-space: nowrap;
            padding: 0.02rem 0.04rem;
            font-family: 'SF Pro Display';
            font-style: normal;
            font-weight: 500;
            font-size: 0.1rem;
            line-height: 0.1rem;
            color: #ffffff;
          }
        }
      }
    }
    .calculationProcess {
    }
    .continue {
      width: 100%;
      height: 0.48rem;
      border-radius: 0.06rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      margin-top: 0.14rem;
      font-family: 'SF Pro Display';
      font-style: normal;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: 0.19rem;
      text-align: center;
      color: #ffffff;

      .rightIcon {
        width: 0.2rem;
        margin-left: 0.08rem;
        span {
          height: 0.17rem;
        }
      }

      &[disabled] {
        background: #0059da;
        opacity: 0.2;
        cursor: no-drop;
      }
      &.continue_true {
        background: #0059da;
        opacity: 1;
        cursor: pointer;
        &:hover {
          background: #0052c9;
        }
        &:active {
          background: #004bb7;
        }
      }
    }
  }

  .footer {
    // height: 0.57rem;
    margin-block: auto 0px;
    overflow: hidden;
  }
}
</style>
